import { IModuleVM } from '../../infrastructure/components/module-vm';
import * as IoC from 'typescript-ioc';
import { IRouter } from '../../infrastructure/router';
import { RouteParams, Routes } from '../../routes-table';
import { action, observable } from 'mobx';
import { Unsubscribe } from 'router5/dist/types/base';
import { RADIX_PARAM } from '../../constants/common.constants';


export enum EventHubModulePage {
    EventHubsList,
    ManageEventHub,
    EventHubWebsiteBuilder
}

export class EventHubsVM implements IModuleVM {
    @observable
    private eventHubModulePage: EventHubModulePage;
    @observable
    private accountId: number;
    @observable
    private eventHubId: number;

    private subscriptions: Unsubscribe[];

    constructor(
        @IoC.Inject private readonly routingService: IRouter<RouteParams> = IoC.Container.get(IRouter)
    ) {
    }

    public didMount(): void {
        this.subscriptions = [];
        this.subscriptions.push(this.routingService.listen(Routes.EventHubList, (params: { accountId: string }) => {
            this.setEventHubModulePage(EventHubModulePage.EventHubsList);
            this.setAccountId(params.accountId);
        }));

        this.subscriptions.push(this.routingService.listenAll([
            Routes.EventHubAttendees,
            Routes.EventHubConfiguration,
        ],
            (params: { accountId: string; eventHubId: string }) => {
                this.setEventHubModulePage(EventHubModulePage.ManageEventHub);
                this.setAccountId(params.accountId);
                this.setEventHubId(params.eventHubId);
        }));

        this.subscriptions.push(this.routingService.listen(Routes.EventHubWebsiteBuilder,
            (params: { accountId: string; eventHubId: string }) => {
                this.setEventHubModulePage(EventHubModulePage.EventHubWebsiteBuilder);
                this.setAccountId(params.accountId);
                this.setEventHubId(params.eventHubId);
        }));
    }

    public willUnmount(): void {
        this.subscriptions.forEach(unsubscribe => unsubscribe());
    }

    public getAccountId(): number {
        return this.accountId;
    }

    public getEventHubId(): number {
        return this.eventHubId;
    }

    public getEventHubModulePage(): EventHubModulePage {
        return this.eventHubModulePage;
    }

    @action
    private setEventHubModulePage(page: EventHubModulePage): void {
        this.eventHubModulePage = page;
    }

    @action
    private setAccountId(accountId: string): void {
        this.accountId = parseInt(accountId, RADIX_PARAM);
    }

    @action
    private setEventHubId(eventHubId: string): void {
        this.eventHubId = parseInt(eventHubId, RADIX_PARAM);
    }

}